import { getPlaces } from '../services/PlacesAPI';
import { getGooglePhotoUrl } from './photoUtils';

export interface PlaceImageData {
  id: string;
  imageUrl: string | null;
}

export async function getPlaceImageByName(placeName: string, placeId: string): Promise<string | null> {
  try {
    const places = await getPlaces(placeName);
    const matchingPlace = places.find(p => p.id === placeId);
    
    if (matchingPlace && matchingPlace.photos && matchingPlace.photos[0]) {
      return getGooglePhotoUrl(matchingPlace.photos[0]);
    }
    return null;
  } catch (error) {
    console.error('Error fetching place image:', error);
    return null;
  }
}

export async function getMultiplePlaceImages(places: Array<{id: string, name: string | null | undefined, city: string | null, country: string | null}>): Promise<PlaceImageData[]> {
  const imagePromises = places.map(async (place) => {
    const searchQuery = `${place.name} ${place.city} ${place.country}`;
    const imageUrl = await getPlaceImageByName(searchQuery, place.id);
    return { id: place.id, imageUrl };
  });
  
  return Promise.all(imagePromises);
}
